import AdminDashboard from '../admin/pages/Dashboard';
import AddFacilityForm from '../admin/pages/AddBillingFacilityForm';
import AddClientForm from '../admin/pages/AddClientForm';
import AddGoalTemplateForm from '../admin/pages/ManageTreatmentPlan/AddGoalTemplateForm';
import AddPayorForm from '../admin/pages/AddPayorForm';
import AddProviderForm from '../admin/pages/AddProviderForm';
import AssessmentSurvey from '../admin/pages/AssessmentSurvey';
import ClientPolicyForm from '../admin/pages/ClientPolicyForm';
import ClientDetails from '../admin/pages/clientDetails';
import EditProviderForm from '../admin/pages/EditProviderForm';
import GoalTemplatePage from '../admin/pages/GoalTemplatePage';
import ChangeSessionStatus from '../admin/pages/ChangeSessionStatus';
import ReassignTreatmentPlan from '../admin/pages/ManageTreatmentPlan/ReassignTreatmentPlan';
import DeleteClaimForm from '../admin/pages/DeleteClaimForm';
import { BulkUnbillableForm } from '../admin/pages/bulkUnbillable';
import { ChangeProviderEmail } from '../admin/pages/changeProviderEmail';
import { ChangeClaimStatusForm } from '../admin/pages/changeClaimStatus';
import AddCohortForm from '../admin/pages/addCohortForm';
import CohortDetailsPage from '../admin/pages/CohortDetailsPage';
import ChangeQaBillingStatus from '../admin/pages/ChangeQaBillingStatus';
import EditClientForm from '../admin/pages/EditClientForm';
import { EmailCronConfigDetailsPage } from '../admin/pages/emailCronConfigs';
import { FieldTemplatesPage } from '../admin/pages/fieldTemplates';
import { Roles } from '../constants';
import ManageTreatmentPlan from '../admin/pages/ManageTreatmentPlan';
import ProviderDetailsPage from '../admin/pages/providerDetails';
import EvvHistory from '../pages/evvHistory';

export const adminRoutes = [
  {
    path: '/admin',
    type: 'private',
    elem: <AdminDashboard />,
    roles: [Roles.OnboardingCoordinator, Roles.Admin, Roles.Biller, Roles.ClientSuccessManager],
  },
  {
    path: '/admin-add-client',
    type: 'private',
    elem: <AddClientForm />,
    roles: [Roles.OnboardingCoordinator, Roles.Admin],
  },
  {
    path: '/admin-add-payor',
    type: 'private',
    elem: <AddPayorForm />,
    roles: [Roles.Admin, Roles.OnboardingCoordinator],
  },
  {
    path: '/admin-add-payor/:payorId',
    type: 'private',
    elem: <AddPayorForm />,
    roles: [Roles.Admin, Roles.OnboardingCoordinator],
  },
  {
    path: '/admin-add-provider',
    type: 'private',
    elem: <AddProviderForm />,
    roles: [Roles.OnboardingCoordinator, Roles.Admin],
  },
  {
    path: '/admin/add-billing-facility',
    type: 'private',
    elem: <AddFacilityForm />,
    roles: [Roles.OnboardingCoordinator, Roles.Admin],
  },
  {
    path: '/admin/create-policy/:clientId',
    type: 'private',
    elem: <ClientPolicyForm />,
    roles: [Roles.OnboardingCoordinator, Roles.Admin, Roles.Biller],
  },
  {
    path: '/admin/edit-policy/:clientId/:policyId',
    type: 'private',
    elem: <ClientPolicyForm />,
    roles: [Roles.OnboardingCoordinator, Roles.Admin, Roles.Biller, Roles.ClientSuccessManager],
  },
  {
    path: '/admin/treatment-plan-management',
    type: 'private',
    elem: <ManageTreatmentPlan />,
    roles: [Roles.Admin, Roles.OnboardingCoordinator],
  },
  {
    path: '/admin/treatment-plan-management/:clientId',
    type: 'private',
    elem: <ManageTreatmentPlan />,
    roles: [Roles.Admin, Roles.OnboardingCoordinator],
  },
  {
    path: '/admin/client-details-page/:clientId',
    type: 'private',
    elem: <ClientDetails />,
    roles: [Roles.Admin, Roles.OnboardingCoordinator, Roles.Biller, Roles.ClientSuccessManager],
  },
  {
    path: '/admin/client/:clientId/edit',
    type: 'private',
    elem: <EditClientForm />,
    roles: [Roles.Admin, Roles.OnboardingCoordinator],
  },
  {
    path: '/admin/provider/:providerId',
    type: 'private',
    elem: <ProviderDetailsPage />,
    roles: [Roles.Admin, Roles.OnboardingCoordinator, Roles.Biller, Roles.ClientSuccessManager],
  },
  {
    path: '/admin/provider/:providerId/edit',
    type: 'private',
    elem: <EditProviderForm />,
    roles: [Roles.Admin, Roles.OnboardingCoordinator],
  },
  {
    path: '/admin/goal-bank/focus-area/:behaviorId/goal-template/:goalTemplateId',
    type: 'private',
    elem: <GoalTemplatePage />,
    roles: [Roles.Admin, Roles.ClientSuccessManager],
  },
  {
    path: '/admin/add-goal-template',
    type: 'private',
    elem: <AddGoalTemplateForm />,
    roles: [Roles.OnboardingCoordinator, Roles.Admin],
  },
  {
    path: '/admin/change-session-status',
    type: 'private',
    elem: <ChangeSessionStatus />,
    roles: [Roles.Admin],
  },
  {
    path: '/admin/reassign-treatment-plan',
    type: 'private',
    elem: <ReassignTreatmentPlan />,
    roles: [Roles.Admin, Roles.OnboardingCoordinator],
  },
  {
    path: '/admin/assessment-survey',
    type: 'private',
    elem: <AssessmentSurvey />,
    roles: [Roles.Admin],
  },
  {
    path: '/admin/delete-claim',
    type: 'private',
    elem: <DeleteClaimForm />,
    roles: [Roles.Admin],
  },
  {
    path: '/admin/bulk-unbillable',
    type: 'private',
    elem: <BulkUnbillableForm />,
    roles: [Roles.Admin],
  },
  {
    path: '/admin/change-claim-status',
    type: 'private',
    elem: <ChangeClaimStatusForm />,
    roles: [Roles.Admin],
  },
  {
    path: '/admin/change-provider-email',
    type: 'private',
    elem: <ChangeProviderEmail />,
    roles: [Roles.Admin],
  },
  {
    path: '/admin/add-cohort',
    type: 'private',
    elem: <AddCohortForm />,
    roles: [Roles.Admin],
  },
  {
    path: '/admin/cohort/:cohortId',
    type: 'private',
    elem: <CohortDetailsPage />,
    roles: [Roles.Admin, Roles.ClientSuccessManager],
  },
  {
    path: '/admin/change-billing-status/:providerId?',
    type: 'private',
    elem: <ChangeQaBillingStatus />,
    roles: [Roles.Admin, Roles.OnboardingCoordinator],
  },
  {
    path: '/admin/email-cron-configs/:configId',
    type: 'private',
    elem: <EmailCronConfigDetailsPage />,
    roles: [Roles.Admin],
  },
  {
    path: '/admin/field-templates',
    type: 'private',
    elem: <FieldTemplatesPage />,
    roles: [Roles.Admin],
  },
  {
    path: '/evv-history',
    type: 'private',
    elem: <EvvHistory />,
    roles: [Roles.Admin],
  },
];
